import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledLoginButton = styled.button`
  width: 100%;
  height: 50px;
  margin-bottom: 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: ${(props: any) =>
    props.backgroundColor
      ? createGradientOrSolid(props.backgroundColor)
      : 'transparent'};
  border: ${(props: any) => (props.backgroundColor ? '0' : '1px solid white')};

  .prefix-icon {
    color: ${(props: any) =>
      props.textColor ? props.textColor.colorOne : 'white'};
    font-size: ${(props: any) => props.iconSize};
    margin-right: 8px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  .text-wrapper {
    display: flex;
    align-items: center;

    div {
      color: ${(props: any) =>
        props.textColor ? props.textColor.colorOne : 'white'};
    }
  }

  &.apple {
    background-color: black;
    border: 0;
  }

  &.google {
    border: 0;
    background-color: white;

    .text-wrapper {
      div {
        color: ${(props: any) =>
          props.textColor ? props.textColor.colorOne : 'rgba(0, 0, 0, 0.54)'};
      }
    }
  }

  &.facebook {
    border: 0;
    background-color: #3975ea;
  }

  &.white {
    background-color: white;

    .text-wrapper {
      div {
        color: ${(props: any) =>
          props.textColor ? props.textColor.colorOne : 'black'};
      }
    }
  }

  img {
    height: ${(props: any) => props.iconSize};
    width: ${(props: any) => props.iconSize};
    margin-right: 16px;
  }

  @media (min-width: 500px) {
    height: 60px;
  }
` as any;
